import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Auth } from "../../../commonPage";
import { Buttton } from "../../../components";
import { Commons } from "../../../utilities";
import { actionCommon } from "../../../redux/actions";
import { useAlert, useModal } from "../../../contexts";
import { FaHospitalUser } from "react-icons/fa";

const LoginPage = () => {
  const patient_access = JSON.parse(localStorage.getItem("patient_access"));
  const isPatientLoggedIn = patient_access?.token;
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const { showModal, hideModal } = useModal();
  const getLanguagesData = useSelector(
    (state) => state.common.getLanguagesData?.data
  );
  useEffect(() => {
    if (isPatientLoggedIn) {
      navigate("/patient/dashboard");
    }
  }, [isPatientLoggedIn, navigate]);

  const loginSubmit = (credentials) => {
    dispatch(
      actionCommon.signIn(credentials, (error, response) => {
        if (error) {
          let errorMessage = `${t("unexpected_error")}`;
          let validationErrors = [];

          if (error?.data) {
            errorMessage =
              error.data.error?.ErrorMessage ||
              error.data.message ||
              errorMessage;

            validationErrors = error.data.error?.ValidationErrors || [];
          }

          if (validationErrors.length > 0) {
            const validationDetails = validationErrors
              .map((err) => `${err.Field}: ${err.Message}`)
              .join("\n");

            errorMessage += `\n\n\nDetails:\n${validationDetails}`;
          }

          if (error?.data?.statusCode === 400) {
            showAlert("danger", errorMessage, `${t("Error")} !`);
          } else {
            showAlert(
              "danger",
              errorMessage,
              `${t("Error")}: ${t("generic_error")}`
            );
          }
        } else if (response) {
          if (response.status === 200) {
            // localStorage.setItem(
            //   "patient_access",
            //   JSON.stringify(response.data.result)
            // );
            showModal({
              title: (
                <div className="message-modal-title-blk">
                  <FaHospitalUser />
                  <p className="exado-title-four">{t("success")}</p>
                </div>
              ),
              bodyContent: <p>{t("Patient.loginPage.success_login")} </p>,
              autoClose: 5000,
              footer: (
                <Buttton.Buttton
                  children={t("okay")}
                  className="btn-solid-Aqua_Teal"
                  onClick={hideModal}
                />
              ),
              className: "message-modal",
            });
            let selectedLang = null;
            if (getLanguagesData?.result) {
              selectedLang = getLanguagesData?.result.find(
                (lang) => lang.languageId === response.data.result.languageId
              );

              if (selectedLang) {
                i18n.changeLanguage(selectedLang.languageAbbreviation);
                localStorage.setItem(
                  "i18nextLng",
                  selectedLang.languageAbbreviation
                );
              }
            }
            const userSession = {
              ...response.data.result,
              languageAbb: selectedLang ? selectedLang.languageAbbreviation : "eng",
            };
            localStorage.setItem("patient_access", JSON.stringify(userSession));
          }
        } else {
        }
      })
    );
  };
  if (isPatientLoggedIn) {
    return null;
  }

  return (
    <Auth.LoginCommonPage
      userType={Commons.userType.patient}
      loginSubmit={loginSubmit}
      subTitle={t("Patient.loginPage.subTitle")}
      loginSide="/doctor/login"
      registerSide="/patient/register"
      forgotSide="/patient/forgot-password"
      closeNavigate="/"
    />
  );
};

export default LoginPage;
